// src/store/interfaceSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSearchFormVisible: true, // Начальное состояние: форма видима
  username: null,
  id: null,
  role: null,
  csvStatistics: null,
  /** { tmRfDate, appRfDate, wipoDates, lastRefreshedAt } с сервера (get_db_actual_dates) */
  dbActualDates: null,
  socketStatus: 'disconnected',
  // Профиль пользователя (локально, без сервера)
  profile: {
    displayName: '',
    bio: '',
    birthDate: null, // ISO string или null
    location: '',
    gender: '',
    avatarDataUrl: null, // data:image/*;base64,
  },
};

const interfaceSlice = createSlice({
  name: 'interface',
  initialState,
  reducers: {
    showSearchForm: (state) => {
      state.isSearchFormVisible = true;
    },
    hideSearchForm: (state) => {
      state.isSearchFormVisible = false;
    },
    toggleSearchForm: (state) => {
      state.isSearchFormVisible = !state.isSearchFormVisible;
    },
    setUser: (state, action) => {
        state.username = action.payload.username;
        state.id = action.payload.id;
        state.role = action.payload.role ?? 'user';
      },
    clearUser: (state) => {
        state.username = null;
        state.id = null;
        state.role = null;
    },
    setCsvStatistics: (state, action) => {
      state.csvStatistics = action.payload;
    },
    clearCsvStatistics: (state) => {
      state.csvStatistics = null;
    },
    setDbActualDates: (state, action) => {
      state.dbActualDates = action.payload;
    },
    setSocketStatus: (state, action) => {
      state.socketStatus = action.payload; // 'connected' | 'connecting' | 'disconnected'
    },
    setProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload };
    },
    setProfileField: (state, action) => {
      const { field, value } = action.payload;
      if (field in state.profile) state.profile[field] = value;
    },
  },
});

export const { showSearchForm, hideSearchForm, toggleSearchForm, setUser, clearUser, setCsvStatistics, clearCsvStatistics, setDbActualDates, setSocketStatus, setProfile, setProfileField } = interfaceSlice.actions;

export default interfaceSlice.reducer;
